import { Component } from '@angular/core'
import { AuthService } from '@shared/services/auth.service'
import { AppUser } from '@shared/models/app-user.model'

@Component({
  selector: 'app-profile-page',
  templateUrl: './profile-page.component.html',
  styleUrls: ['./profile-page.component.scss'],
})
export class ProfilePageComponent {
  currentUser: AppUser | null = null
  showDeletePopup = false

  constructor(private authService: AuthService) {
    console.log('Missing feature: fetch user from auth service')
    this.currentUser = this.authService.getCurrentUser() || null
  }

  openDeletePopup(): void {
    this.showDeletePopup = true
  }

  closeDeletePopup(): void {
    this.showDeletePopup = false
  }
}
